import { useMemo } from "react";

import {
  NotificationEntityType,
  NotificationsQuery,
  NotificationsQueryVariables,
  useNotificationsQuery,
} from "@/apollo/types";
import { QueryHookOptions } from "@apollo/client";

export const useNotifications = (
  options?: QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>,
) => {
  const { data, loading, error, refetch } = useNotificationsQuery(options);

  const notifications = useMemo(() => {
    if (!data) return [];
    return data?.notifications;
  }, [data]);

  return { notifications, loading, error, refetch };
};

export const useAccountNotifications = () => {
  const { notifications, loading } = useNotifications();
  return {
    notifications: notifications.filter(
      (x) => x.entityType === NotificationEntityType.Account,
    ),
    loading,
  };
};
